import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { SIGNUP, LOGIN, ACTIVATE, OTPVERIFY, SHAREWIN, PREDICT, PROFILE, REFEREWIN, DASHBOARD, FORGOTPASSWORD, RESETPASSWORD } from "../helpers/Constant";
import { Splash, Login, Signup, OTPScreen, ResetPasswordOTP, Dashboard, ShareWin, Profile, RefereWin, MatchDetails, ResetPasswordScreen, ForgotPasswordScreen } from "../pages/index";

const RoutesHome = () => {
  return (
    <Routes>
      <Route path={`/`} element={<Splash />} />
      <Route path={`/${LOGIN}`} element={<Login />} />
      <Route path={`/${SIGNUP}`} element={<Signup />} />
      <Route path={`/${ACTIVATE}`} element={<OTPScreen />} />
      <Route path={`/${OTPVERIFY}`} element={<ResetPasswordOTP />} />
      <Route path={`/${FORGOTPASSWORD}`} element={<ForgotPasswordScreen />} />
      <Route path={`/${RESETPASSWORD}`} element={<ResetPasswordScreen />} />
      <Route path={`/${DASHBOARD}`} element={<Dashboard />} />
      <Route path={`/${SHAREWIN}`} element={<ShareWin />} />
      <Route path={`/${PROFILE}`} element={<Profile />} />
      <Route path={`/${REFEREWIN}`} element={<RefereWin />} />
      <Route path={`/${PREDICT}`} element={<MatchDetails />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default RoutesHome;
